/**
 * IRSP Submissions Vuex Getters
 */
export default {
  /**
   * Get all submissions
   * @param {Object} state - Vuex state
   * @returns {Array} Submissions array
   */
  submissions(state) {
    return state.submissions
  },

  /**
   * Get pagination state
   * @param {Object} state - Vuex state
   * @returns {Object} Pagination object
   */
  pagination(state) {
    return state.pagination
  },

  /**
   * Get loading state
   * @param {Object} state - Vuex state
   * @returns {boolean} Loading state
   */
  isLoading(state) {
    return state.isLoading
  },

  /**
   * Get refreshing state
   * @param {Object} state - Vuex state
   * @returns {boolean} Refreshing state
   */
  isRefreshing(state) {
    return state.isRefreshing
  },

  /**
   * Get error state
   * @param {Object} state - Vuex state
   * @returns {string|null} Error message
   */
  error(state) {
    return state.error
  },

  /**
   * Get submission by UUID
   * @param {Object} state - Vuex state
   * @returns {Function} Finder function
   */
  getSubmissionByUuid: (state) => (uuid) => {
    return state.submissions.find((s) => s.uuid === uuid)
  },

  /**
   * Get count of submissions by status
   * @param {Object} state - Vuex state
   * @returns {Function} Counter function
   */
  getCountByStatus: (state) => (status) => {
    return state.submissions.filter((s) => s.statusOverall === status).length
  },

  /**
   * Check if there are any pending submissions
   * @param {Object} state - Vuex state
   * @returns {boolean} Has pending submissions
   */
  hasPendingSubmissions(state) {
    return state.submissions.some((s) => 
      ['Submitted', 'Processing'].includes(s.statusOverall)
    )
  },

  /**
   * Check if there are any submissions with errors
   * @param {Object} state - Vuex state
   * @returns {boolean} Has error submissions
   */
  hasErrorSubmissions(state) {
    return state.submissions.some((s) => 
      ['Error', 'Rejected'].includes(s.statusOverall)
    )
  },

  /**
   * Get submissions filtered by status
   * @param {Object} state - Vuex state
   * @returns {Function} Filter function
   */
  getSubmissionsByStatus: (state) => (statuses) => {
    if (!statuses || statuses.length === 0) return state.submissions
    return state.submissions.filter((s) => statuses.includes(s.statusOverall))
  },

  /**
   * Get total items count
   * @param {Object} state - Vuex state
   * @returns {number} Total items
   */
  totalItems(state) {
    return state.pagination.totalItem
  },

  /**
   * Check if there are more pages to load
   * @param {Object} state - Vuex state
   * @returns {boolean} Has more pages
   */
  hasMorePages(state) {
    return state.pagination.currentPage < state.pagination.totalPage
  },
}
